import dayjs from 'dayjs';

const TIMEZONE_DATE_FORMAT = {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
  hour12: true,
  timeZoneName: 'short',
};

function formatTimeZoneDateTime(value) {
  if (!value) return { localDatetime: '', systemDatetime: '' };
  const datetime = dayjs(value);

  const localDatetime = new Intl.DateTimeFormat(
    undefined,
    TIMEZONE_DATE_FORMAT,
  ).format(datetime.toDate());

  const systemDatetime = new Intl.DateTimeFormat(undefined, {
    ...TIMEZONE_DATE_FORMAT,
    timeZone: 'UTC',
  }).format(datetime.toDate());

  return {
    localDatetime,
    systemDatetime,
  };
}

export default formatTimeZoneDateTime;
